import React from "react";
import { Modal } from "react-bootstrap";
import ENVIRONMENT from "../../../../config/environment";

function ZatcaModal({
  show,
  onHide,
  title,
  description,
  primaryActionText,
  secondaryActionText,
  secondaryColor,
  disabled,
  applyCustomWidth,
  onConfirm,
  onFailure,
}) {
  const language = localStorage.getItem("language");
  return (
    <Modal show={show} onHide={onHide} centered className={`${language === "arabic" ? "rtl" : "ltr"} ${applyCustomWidth ? "zatca-modal-short" : ""}`}>
      <Modal.Body>
        <div className="bg-white">
          {title ? <div className="revoke-modal-title mb-5 pb-5">{title}</div> : null}
          <div className="revoke-modal-desc mb-5 pb-5">{description}</div>
          <div className="d-flex justify-content-end align-items-center" style={{ gap: "1rem" }}>
            <div className="footer-primary-text" onClick={onHide}>
              {primaryActionText}
            </div>
            {ENVIRONMENT.showTestTools && onFailure ? (
              <div className="footer-secondary-text" onClick={onFailure}>
                Simulate Failure
              </div>
            ) : null}

            {secondaryColor ? (
              <div style={{ color: disabled ? "#D9D9D9" : secondaryColor }} className="footer-text-normal" onClick={onConfirm ? onConfirm : onHide}>
                {secondaryActionText}
              </div>
            ) : (
              <div className="footer-secondary-text" onClick={onConfirm ? onConfirm : onHide}>
                {secondaryActionText}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ZatcaModal;
